import Cookies from 'js-cookie'
import { getsysconfig } from '@/api/system'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  language: Cookies.get('language') || 'en',
  size: Cookies.get('size') || 'medium',
  height:950,
  system:'',
  adminUrl: '',
  dcmviwerurl: '', // 
  appInfo: '',
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language
    Cookies.set('language', language)
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  },
  SET_WINDOW_HEIGHT(state, height){
    if(height){
     state.height = height
    }
  },
  SET_SYSTEM_TYPE(state, type){
     state.system = type
  },
  SET_ADMIN_URL(state,url){
    state.adminUrl = url
  },
  SET_DCMVIWER_URL(state,url){
    state.dcmviwerurl = url
  },
  SET_APPINFO(state,info){
    state.appInfo = info
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  setWindowHeight({ commit}, height){
    commit('SET_WINDOW_HEIGHT', height)
  },
  setSystemType({commit},type){
    return new Promise((resolve, reject) => {
      getsysconfig().then(res=>{
          if(res.info == 'ok'){
            res.productinfo.info.productname = res.productinfo.productname;
            commit('SET_SYSTEM_TYPE',res.islocal);
            commit('SET_ADMIN_URL',res.url);
            commit('SET_DCMVIWER_URL',res.dcmviwerurl);
            commit('SET_APPINFO',res.productinfo.info)
            resolve()
          }else{
            resolve()
          }
      }).catch(error=>{
       console.log('catch:', error);
      });
    }).catch(error => {
      reject(error)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
